import React from "react";
import { useEffect } from "react";

const JiraIssueCollector = () => {
	useEffect(() => {
	  // Create a script element
	  const script = document.createElement("script");
	  script.type = "text/javascript";
	  script.src =
		"https://abcopro.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/g2slup/b/9/c95134bc67d3a521bb3f4331beb9b804/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=dcc21dd1";
	  script.async = true;
  
	  // Append script to body
	  document.body.appendChild(script);
  
	  return () => {
		// Remove script when component unmounts
		if (script.parentNode) {
			script.parentNode.removeChild(script);
		}
		// Also remove any global variables or event listeners the script might have added
		if (typeof window !== 'undefined' && (window as any).JIRA) {
			delete (window as any).JIRA;
		}
	  };
	}, []);
  
	return (<></>
	);
  };
  

export default JiraIssueCollector;
